import React from "react";
import { makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import { handleNumber } from "../../../../../method/displayData";


let useStyles = makeStyles((theme) => ({
    root: {
        width: '90%',
        padding: '20px',
       textAlign:'center',
       margin:'auto',
       marginTop:120,
       [theme.breakpoints.down("700")]: {
        marginTop:25,
     },
    },
}))

export default function Index() {

    let classes = useStyles();
    const stateReducer = useSelector((state) => state.bourse_select_instruments_reducer);

    return (
        <div className={classes['root']}>
            <p>
                {`
    ${handleNumber(stateReducer?.total)} معامله انجام شده است.
    `}
            </p>
        </div>)
}
